import Image from 'next/image'
import { BoraTheme } from '@/root/shared-types'
interface LogoProps {
  clientName: BoraTheme
  width: number
  height: number
  logo: string
  altText?: string
  className?: string
}
const ClientLogo = ({ clientName, width, height, logo, altText, className }: LogoProps) => {
  return (
    <Image
      alt={altText || `${clientName} logo`}
      src={`/${clientName}/images/${logo}.svg`}
      width={width}
      height={height}
      className={className}
      priority={true}
    />
  )
}

export default ClientLogo
